import { collection } from 'typesaurus';
export const users = collection('users');
